import PrtIcon from '@/components/atoms/PrtIcon/PrtIcon.vue'
export default {
	name: 'PrtFooter',
	components: {
		PrtIcon
	}
}
